export const DROPDOWN_DEFAULT_WIDTH = 300;

export const DROPDOWN_DEFAULT_HEIGHT = 210;

export const SELECTED_ALL_ID = "select-all-id";
